import ToolbarAdd from './toolbar-add.jsx';
import ToolbarStyles from './toolbar-styles.jsx';

export default {
	[ToolbarAdd.key]: ToolbarAdd,
	[ToolbarStyles.key]: ToolbarStyles,
};
